const initialState = {
    filtered_threads: [],
    filtered_pagination: {
        filtered_pagination_has_next_page: null,
        filtered_pagination_current_page: null,
        filtered_pagination_total: null,
    },
    chat_popup: {
        id: null,
        old_scroll: 0
    }
}

export default function chat(state = initialState, action) {
    switch(action.type) {
       

    

        case 'REPLACE_ALL_FILTERED_THREADS':
            return {
                ...state,
                filtered_threads: action.payload.threads,
                filtered_pagination: {
                    filtered_pagination_has_next_page: action.payload.pagination_has_next_page,
                    filtered_pagination_current_page: action.payload.pagination_current_page,
                    filtered_pagination_total: action.payload.pagination_total,
                }
            }    
        
        

        case 'APPEND_FILTERED_THREADS':
            return {
                ...state,
                filtered_threads: [...state.filtered_threads, ...action.payload.threads],
                filtered_pagination: {
                    filtered_pagination_has_next_page: action.payload.pagination_has_next_page,
                    filtered_pagination_current_page: action.payload.pagination_current_page,
                    filtered_pagination_total: action.payload.pagination_total,
                }
            }  
            
        case 'SET_CHAT_POPUP':
            return {
                ...state,
                chat_popup: {
                    id: action.payload.id,
                    old_scroll: action.payload.old_scroll
                }
            }
        
        default:
            return state 
    }
}